<template>
    <div v-if="settings.show">
        <b-modal v-model="showGpsPopup"
                 :content-class=" 'custom-modal gps-popup ' + (settings.sectionClass ? settings.sectionClass : '')">
            <template v-slot:modal-header="{ close }">
                <span class="close-icon" @click="onCancelClick"></span>
            </template>
            <div>
                <div class="modal-icon">
                    <img src="../../assets/icons/gps_popup_icon.svg">
                </div>
                <div class="modal-subtitle">{{description}}</div>
                <div class="modal-alarm__text">{{translate('manageGPSPopupSureNewCoords')}}</div>
                <div class="modal-map" @click="onMapClick">
                    <img
                        :src="mapUrl" class="modal-map-img"/>
                    <div class="map-point" v-if="this.type != 'distance'">
                        <img src="../../assets/icons/map-point.png">
                    </div>
                </div>
            </div>
            <template v-slot:modal-footer>
                <div class="footer-buttons">
                    <div class="black-btn" @click="onUseLocationClick">{{translate('manageGPSPopupUseNewCoordsBtn')}}</div>
                    <div class="white-btn" @click="onChangeManuallyClick">{{translate('manageGPSPopupChangeManuallyBtn')}}</div>
                    <div class="white-btn" @click="onCancelClick">{{translate('Cancel')}}</div>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import _ from "lodash";
    import config from '@/api/config';
    import geoLocationMixin from "@/mixins/geoLocationMixin";
    import mapMixin from "@/mixins/mapMixin";

    export default {
        name: "gpsPopup",
        mixins: [geoLocationMixin, mapMixin],
        data() {
            return {
                showGpsPopup: _.isEmpty(this.settings),
                gpsTeg: false,
                mapApiKey: config.STATIC_MAP_API_KEY
            }
        },
        props: {
            settings: {
                type: [Object, null],
                default: () => {
                    return {
                        distance: 0,
                    }
                }
            },
        },
        watch: {
            settings(newValue) {
                this.showGpsPopup = !_.isEmpty(newValue)
            }
        },
        computed: {
            description() {
                let dist = this.settings.distance
                let accuracy = Math.round(this.settings.accuracy)
                if (dist !== null && dist > this.maxCoordsDistance && accuracy < this.maxOkAccurancy) {
                    return  this.translate('manageGPSPopupTitle', [dist])
                } else if (dist !== null && dist > this.maxCoordsDistance && accuracy > this.maxOkAccurancy){
                    return this.translate('manageGPSPopupBadAccuracyAndLongDistance', [dist, accuracy])
                } else {
                    return this.translate('manageGPSPopupBadAccuracy', [accuracy])
                }
            },
            mapUrl() {
                if(this.type == 'distance') {
                    let url = `https://maps.googleapis.com/maps/api/staticmap?markers=color:red%7Clabel:n%7C${this.settings.lat},${this.settings.lng}&markers=color:blue%7Clabel:o%7C${this.settings.oldLat},${this.settings.oldLng}&size=604x400&key=${this.mapApiKey}`
                    console.log(url)
                    if(this.settings.accuracy > this.maxOkAccurancy) {
                        url += this.GMapCircle(this.settings.lat, this.settings.lng, this.settings.accuracy)
                    }
                    return url
                } else {
                    let url = `https://maps.googleapis.com/maps/api/staticmap?center=${this.settings.lat},${this.settings.lng}&zoom=18&size=604x400&key=${this.mapApiKey}`
                    url += this.GMapCircle(this.settings.lat, this.settings.lng, this.settings.accuracy)
                    return url
                }
            },
            locationData: {
                get () {
                    return this.$store.state.questionManage.locationData
                },
                set (value) {
                    this.$store.commit('questionManage/setLocationData', value)
                }
            },

            type() {
                return (this.settings.distance !== null && this.settings.distance > this.maxCoordsDistance) ? 'distance' : 'accuracy'
            },
        },
        methods: {
            async onMapClick() {
                this.onChangeManuallyClick()
            },
            async onUseLocationClick() {
                this.showGpsPopup = false
                if (this.settings.useLocationHandler) {
                    try {
                        await this.settings.useLocationHandler()
                    } catch (error) {
                        this.showErrorModal(error.message)
                    }
                }
            },
            async onChangeManuallyClick() {
                this.showGpsPopup = false
                if (this.settings.changeManuallyHandler) {
                    try {
                        await this.settings.changeManuallyHandler()
                    } catch (error) {
                        this.showErrorModal(error.message)
                    }
                }
            },
            onCancelClick() {
                this.showGpsPopup = false
            },
        },
    }
</script>
<style>
.gps-popup .modal-header .close {
    visibility: hidden;
}
</style>
<style scoped>
    .modal-icon {
        margin-top: -35px;
    }
    .modal-subtitle {
        font-family: Nunito;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 24px;
        margin-top: 15px;
    }
    .modal-map {
        position: relative;
    }
    .modal-map-img {
        position: relative;
        width: 100%;
    }
    .modal-alarm__text {
        color: #EB5757;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 24px;
        margin-top: 6px;
        margin-bottom: 15px;
    }
    .map-point {
        width: 32px;
        position: absolute;
        transform: translate(-50%, -100%);
        top: 50%;
        left: 50%;
    }
    .footer-buttons {
        width: 100%;
    }
    .black-btn {
        font-family: Nunito;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 24px;
        background-color: #3F405C;
        padding: 12px;
        color: white;
        width: 100%;
        border-radius: 6px;
    }
    .white-btn {
        padding: 12px;
        color: #3F405C;
        border: 2px solid #3F405C;
        box-sizing: border-box;
        border-radius: 6px;
        margin-top: 8px;
    }
    .custom-modal .close-icon {
        width: 50px;
        height: 50px;
        margin-right: -10px;
        margin-top: -10px;
    }
</style>